"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDhig2021DarkObject = exports.getDhig2021Object = exports.dhig2021DarkObjectMeta = exports.dhig2021ObjectMeta = void 0;

var _dhig2021ThemeBase = require("./dhig2021-theme-base");

var _designTokens = _interopRequireDefault(require("@digital-hig/theme-data/lib/build/json/light/design-tokens.json"));

var _componentTokens = _interopRequireDefault(require("@digital-hig/theme-data/lib/build/json/light/component-tokens.json"));

var _designTokens2 = _interopRequireDefault(require("@digital-hig/theme-data/lib/build/json/dark/design-tokens.json"));

var _componentTokens2 = _interopRequireDefault(require("@digital-hig/theme-data/lib/build/json/dark/component-tokens.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Merges a Material-UI base theme with theme data
 */
var _lightDesignTokens$pr = _designTokens.default.primitives.colors.primary,
    black = _lightDesignTokens$pr.black,
    white = _lightDesignTokens$pr.white;

var getDhig2021Object = function getDhig2021Object(additionalThemeOptions) {
  var theme = (0, _dhig2021ThemeBase.getThemeBase)(_objectSpread({
    themeData: _objectSpread(_objectSpread({}, _designTokens.default), {}, {
      tokens: _objectSpread(_objectSpread({}, _designTokens.default.tokens), _componentTokens.default.tokens)
    })
  }, additionalThemeOptions));
  return {
    theme: theme
  };
};

exports.getDhig2021Object = getDhig2021Object;
var dhig2021ObjectMeta = {
  color: black,
  name: "dhig2021"
};
exports.dhig2021ObjectMeta = dhig2021ObjectMeta;

var getDhig2021DarkObject = function getDhig2021DarkObject(additionalThemeOptions) {
  var theme = (0, _dhig2021ThemeBase.getThemeBase)(_objectSpread({
    paletteType: "dark",
    themeData: _objectSpread(_objectSpread({}, _designTokens2.default), {}, {
      tokens: _objectSpread(_objectSpread({}, _designTokens2.default.tokens), _componentTokens2.default.tokens)
    })
  }, additionalThemeOptions));
  return {
    theme: theme
  };
};

exports.getDhig2021DarkObject = getDhig2021DarkObject;
var dhig2021DarkObjectMeta = {
  color: white,
  name: "dhig2021Dark"
};
exports.dhig2021DarkObjectMeta = dhig2021DarkObjectMeta;